/* GM · CRO — Barra de progreso del carrito por PARES (2 hitos). Se actualiza en vivo.
   2026-10-01: cuenta pares (item_count) en vez de euros; los tramos vienen en data-gm-*.
   No depende de internals del tema: escucha eventos + re-lee /cart.js + MutationObserver. */
(function () {
  'use strict';

  function pct(p) { return '<strong>' + p + '&nbsp;%</strong>'; }

  function mensaje(count, n1, p1, n2, p2, dos) {
    var falta1 = n1 - count, falta2 = n2 - count;
    if (count < n1) {
      if (count === 0) return 'Llévate <strong>' + n1 + ' pares</strong> y ahorra un ' + pct(p1) + ' en todo el pedido';
      if (falta1 === 1) return 'Añade <strong>otro par</strong> y llévate un ' + pct(p1) + ' en todo el pedido';
      return 'Añade <strong>' + falta1 + ' pares más</strong> y llévate un ' + pct(p1) + ' en todo el pedido';
    }
    if (dos && count < n2) {
      return '<strong>¡' + p1 + '&nbsp;% conseguido!</strong> Con ' + (falta2 === 1 ? '<strong>un par más</strong>' : '<strong>' + falta2 + ' pares más</strong>') + ', sube al ' + pct(p2);
    }
    return '<strong>¡Genial!</strong> Tienes un ' + pct(dos ? p2 : p1) + ' de descuento en todo el pedido 🎉';
  }

  function render(root, count) {
    var n1 = parseInt(root.getAttribute('data-gm-n1'), 10) || 2;
    var p1 = parseInt(root.getAttribute('data-gm-p1'), 10) || 10;
    var n2 = parseInt(root.getAttribute('data-gm-n2'), 10) || n1;
    var p2 = parseInt(root.getAttribute('data-gm-p2'), 10) || p1;
    var dos = root.getAttribute('data-gm-dos') === 'true';
    count = Math.max(0, count | 0);

    var stage = count >= n1 ? 1 : 0;
    if (dos && count >= n2) stage = 2;
    var fill = Math.min(100, Math.round((count * 100) / n2));

    var fillEl = root.querySelector('[data-gm-fill]');
    if (fillEl) fillEl.style.width = fill + '%';
    var n1El = root.querySelector('.gm-prog__node--1');
    var n2El = root.querySelector('.gm-prog__node--2');
    if (n1El) n1El.classList.toggle('is-done', stage >= 1);
    if (n2El) n2El.classList.toggle('is-done', dos ? stage >= 2 : stage >= 1);

    var msg = root.querySelector('[data-gm-msg]');
    if (msg) {
      var html = mensaje(count, n1, p1, n2, p2, dos);
      if (msg.innerHTML !== html) msg.innerHTML = html;
    }
    root.setAttribute('data-gm-stage', String(stage));
  }

  var last = null;      // último número de pares conocido
  var painting = false; // evita bucle con el MutationObserver

  function paint() {
    if (painting) return;
    painting = true;
    try {
      var bars = document.querySelectorAll('[data-gm-progress]');
      for (var i = 0; i < bars.length; i++) {
        var c = last;
        if (c == null) { c = parseInt(bars[i].getAttribute('data-gm-count'), 10); if (isNaN(c)) c = 0; }
        render(bars[i], c);
      }
    } finally {
      setTimeout(function () { painting = false; }, 0);
    }
  }

  function sync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') { last = c.item_count; paint(); } })
      .catch(function () {});
  }

  function boot() {
    paint();  // pinta con el estado servido de inmediato
    sync();   // confirma con la fuente de verdad

    var host = document.querySelector('[data-cart-drawer]') || document.body;
    try {
      new MutationObserver(function () { paint(); }).observe(host, { childList: true, subtree: true });
    } catch (e) {}

    ['theme:cart:refresh', 'theme:cart:added', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(sync, 400); });
    });
    try {
      if (window.theme && theme.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
        window.subscribe(theme.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 60); });
      }
    } catch (e) {}
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
